var map = {
	"./vab-blue-variables.module.scss": "./library/styles/variables/vab-blue-variables.module.scss",
	"./vab-green-variables.module.scss": "./library/styles/variables/vab-green-variables.module.scss",
	"./vab-purple-variables.module.scss": "./library/styles/variables/vab-purple-variables.module.scss",
	"./vab-red-variables.module.scss": "./library/styles/variables/vab-red-variables.module.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./library/styles/variables sync recursive ^\\.\\/vab\\-.*\\-variables\\.module\\.scss$";